import { ConnectionState, StreamingState } from '@d-id/client-sdk';
import { useEffect, useState } from 'react';

interface StateProps {
    connectionState: ConnectionState;
    videoState: StreamingState;
    agentPreviewReady: boolean;
    speak: () => void;
}
export const useAgentState = ({ connectionState, videoState, agentPreviewReady, speak }: StateProps) => {
    const [shouldStartTalk, setShouldStartTalk] = useState(false);
    const [speakLoading, setSpeakLoading] = useState(false);

    const showVideo = connectionState === ConnectionState.Connected && videoState === StreamingState.Start;
    const showPlayButton =
        !speakLoading &&
        !showVideo &&
        agentPreviewReady &&
        (connectionState === ConnectionState.Connecting || videoState === StreamingState.Stop) &&
        connectionState !== ConnectionState.Fail;

    // when the video is playing, stop the loader
    useEffect(() => {
        if (showVideo && speakLoading) {
            setSpeakLoading(false);
        }
    }, [showVideo, speakLoading]);

    // when the video is ready to play, start speaking
    useEffect(() => {
        if (shouldStartTalk && connectionState === ConnectionState.Connected) {
            setShouldStartTalk(false);
            speak();
        }
    }, [shouldStartTalk, connectionState]);

    return { showVideo, showPlayButton, speakLoading, setShouldStartTalk, setSpeakLoading };
};
